export default "__VITE_ASSET__695de65d__"